<div class="d-flex w-100 px-2 pt-3">
  <h2 mat-dialog-title>SIGN UP</h2>
</div>
<mat-dialog-content class="dialog-container pt-3">
  <div class="container-fluid">
    <!-- <p class="text-center">Sign Up with exisiting accounts</p>-->

    <!-- social buttons -->

    <!-- <div class="row justify-content-center my-3">
      <div class="col-12 text-center">Or login with</div>
      <div class="col-12 d-flex justify-content-center">
        <div class="mx-1">
          <a tabindex="-1" class="social-button btn-outline-dark" [href]="getSocialLoginURL('facebook')">
            <i class="bi bi-facebook"></i>
          </a>
        </div>
        <div class="mx-1">
          <a tabindex="-1" class="social-button btn-outline-dark d-grid app-place-content-center"
            [href]="getSocialLoginURL('google')">
            <i class="bi bi-google"></i>
          </a>
        </div>
      </div>
    </div>-->

    <form class="mt-2" [formGroup]="signUpForm" (ngSubmit)="signup()">
      <div class="row justify-content-center">
        <div class="col-10 mb-3">
          <!-- first name -->
          <div class="mb-3">
            <input type="text" class="form-control" placeholder="First Name" formControlName="firstName" />
            <small class="text-danger"
              *ngIf="signUpForm.get('firstName')?.touched && signUpForm.get('firstName')?.errors?.['required']">First
              Name is Required</small>
          </div>

          <!-- last name -->
          <div class="mb-3">
            <input type="text" class="form-control" placeholder="Last name" formControlName="lastName" />
            <small class="text-danger"
              *ngIf="signUpForm.get('lastName')?.touched && signUpForm.get('lastName')?.errors?.['required']">Last Name
              is Required</small>
          </div>

          <!-- email -->
          <div class="mb-3">
            <input type="email" class="form-control" placeholder="name@example.com" formControlName="email" />
            <div *ngIf="signUpForm.get('email')?.touched">
              <small class="text-danger" *ngIf="signUpForm.get('email')?.errors?.['email']">Enter a valid email address
                like john@test.com</small>
              <small class="text-danger" *ngIf="signUpForm.get('email')?.errors?.['required']">Email id is
                Required</small>
            </div>
          </div>

          <!-- mobile -->
          <div class="mb-3">
            <input type="tel" class="form-control" placeholder="Mobile number" formControlName="mobileNumber" />
            <div *ngIf="signUpForm.get('mobileNumber')?.touched">
              <small class="text-danger" *ngIf="signUpForm.get('mobileNumber')?.errors?.['pattern']">Enter a valid
                mobile number</small>
              <small class="text-danger" *ngIf="signUpForm.get('mobileNumber')?.errors?.['required']">Mobile Number is
                Required</small>
            </div>
          </div>

          <!-- password -->
          <div class="mb-3">
            <div class="input-group">
              <input [type]="passwordInputType" class="form-control" placeholder="Password"
                formControlName="password" />
              <button class="app-icon-btn position-absolute end-0 border-0" type="button"
                (click)="togglePasswordType(passwordInputTypes.passwordInputType)">
                <i [ngClass]="[
                  'bi',
                  passwordInputType === 'password'
                    ? 'bi-eye-fill'
                    : 'bi-eye-slash-fill'
                ]"></i>
              </button>
            </div>

            <div *ngIf="signUpForm.get('password')?.touched">
              <!-- {{signUpForm.get('password')?.errors | json}} -->
              <small class="text-danger" *ngIf="signUpForm.get('password')?.errors?.['minlength']">Must be at least 6
                characters long</small>
              <small class="text-danger" *ngIf="signUpForm.get('password')?.errors?.['required']">Password is
                Required</small>
              <small class="text-danger" *ngIf="signUpForm.get('password')?.errors?.['passwordPatternMatch']">
                {{signUpForm.get('password')?.errors?.['passwordPatternMatch'].message}}
              </small>
            </div>
          </div>

          <!-- repeat password -->
          <section class="mb-3">
            <div class="input-group">
              <input [type]="repeatPasswordInputType" class="form-control" placeholder="Repeat password"
                formControlName="matchingPassword" />
              <button class="app-icon-btn position-absolute end-0 border-0" type="button" (click)="
              togglePasswordType(passwordInputTypes.repeatPasswordInputType)
            ">
                <i [ngClass]="[
                'bi',
                repeatPasswordInputType === 'password'
                  ? 'bi-eye-fill'
                  : 'bi-eye-slash-fill'
              ]"></i>
              </button>
            </div>

            <div *ngIf="signUpForm.get('matchingPassword')?.touched">
              <small class="text-danger" *ngIf="signUpForm.get('matchingPassword')?.errors?.['required']">Repeat
                Password is Required</small>

              <span *ngIf="signUpForm?.get('matchingPassword')?.errors?.['passwordMisMatch']" class="text-danger">
                Password and Repeat Password should be the same
              </span>
              <small class="text-danger" *ngIf="signUpForm.get('matchingPassword')?.errors?.['minlength']">Must be at
                least 6 characters long</small>
            </div>
          </section>

          <!-- T&C accept -->
          <div class="mb-3">
            <label>
              <input type="checkbox" name="terms" formControlName="termsAndConditions" />
              I accept the <a href="https://www.shopbrandnew.com/sitePage/terms-of-use" target="_blank"
                class="text-decoration-none cursor-pointer">terms and conditions</a>
            </label>
          </div>

          <!-- Sign up button -->
          <div class="text-center">
            <button class="btn app-btn-dark text-uppercase" [disabled]="signUpForm.invalid" type="submit">Sign
              up</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions> -->
<div class="container-fluid mb-2 footer">
  <div class="row align-items-center justify-content-between py-2">
    <div class="col-8">
      Already have an account ?
      <!-- <button class="btn btn-link" (click)="openLoginModal()">Login</button>-->
    </div>
    <div class="col-4 text-end">
      <button class="btn app-btn-dark text-uppercase" type="button" (click)="openLoginModal()">Login</button>
    </div>
  </div>
</div>
<!-- </mat-dialog-actions> -->
